import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Card, CardContent, Grid, Typography, useTheme } from "@mui/material";

import { pathRoute } from "../../../Utils/Routes/routes";

interface Props {
  accountName?: string;
}
export default function ConfirmationSuccessSentResetPassword({ accountName }: Props) {
  const navigate = useNavigate();
  const theme = useTheme();
  useEffect(() => {
    const time = setTimeout(() => {
      navigate(pathRoute.SignIn.Index, { replace: true });
    }, 5000);

    return () => clearTimeout(time);
  }, []);

  return (
    <Card sx={{ backgroundColor: theme.palette.background.paper }}>
      <CardContent>
        <Grid container flexDirection="column" alignItems="center">
          <Typography gutterBottom variant="h5" component="h2">
            Account recovery email sent
          </Typography>
          {/* <Typography gutterBottom variant="h5" component="h2">
          {accountName}
        </Typography> */}
          <Typography variant="body2" color="textSecondary" component="p">
            Check your email for instructions to reset your password. If you do not see this email
            in your inbox within 15 minutes, look for it in your junk mail folder. If you find it
            there, please mark it as “Not Junk”.
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
}
